import * as stylex from "@stylexjs/stylex";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { colors } from "../materials/consts.stylex";
import { Button } from "./button";
const variants = {
    enter: (direction)=>{
        return {
            x: direction > 0 ? 1000 : -1000,
            position: "absolute",
            left: 0
        };
    },
    center: {
        zIndex: 1,
        x: 0,
        position: "static"
    },
    exit: (direction)=>{
        return {
            position: "absolute",
            left: 0,
            zIndex: 0,
            x: direction < 0 ? 1000 : -1000
        };
    }
};
const DefaultFooterComponent = ({ paginate })=>{
    return <div className="x78zum5 x1qughib">
      <Button rounded inverted inline onClick={()=>paginate(-1)}>
        Previous
      </Button>
      <Button rounded inline onClick={()=>paginate(+1)}>
        Next
      </Button>
    </div>;
};
export default function Carousel({ children: rawChildren, onSlideChange, FooterComponent = DefaultFooterComponent }) {
    const children = rawChildren instanceof Array ? rawChildren : [
        rawChildren
    ];
    const [[page, direction], setPage] = useState([
        0,
        0
    ]);
    const count = children.length;
    const paginate = (newDirection)=>{
        const newPageNumber = (page + count + newDirection) % count;
        setPage([
            newPageNumber,
            newDirection
        ]);
        onSlideChange?.(newPageNumber);
    };
    return <div className="x1o2sk6j x1n2onr6 xndqk7f">
      {count > 1 && <div className="xhbfen4">
          {Array(count).fill(null).map((_, i)=>{
        return <motion.div key={i} onClick={()=>setPage((p)=>[
                    i,
                    p[0] < i ? -1 : 1
                ])} initial={false} animate={{
            width: i === page ? 32 : 12
        }} {...{
            0: {
                className: "x1rg5ohu x1jfeucu xygnafs xpoiemb x1ycjhwn x1cum3z5 xgxxoiu x1ypdohk x1n2onr6 x1nhnfej x1hmns74 x1nxnffj x2hztxu x1xhnyyv x1rmj1tg xo890a5 x1fhgk32 xwx4but"
            },
            1: {
                className: "x1rg5ohu xpoiemb x1ycjhwn x1cum3z5 xgxxoiu x1ypdohk x1n2onr6 x1nhnfej x1hmns74 x1nxnffj x2hztxu x1xhnyyv x1rmj1tg xo890a5 x1fhgk32 xwx4but x6e1os3 xygnafs"
            }
        }[!!(i === page) << 0]}>
                  {i}
                </motion.div>;
    })}
        </div>}
      <motion.div className="x78zum5 xb3r6kr x1n2onr6 x1ghz6dp">
        <AnimatePresence initial={false} custom={direction}>
          <motion.div className="xh8yej3 x2lah0s xb3r6kr" key={page} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
        x: {
            type: "spring",
            stiffness: 300,
            damping: 30
        }
    }}>
            {children[page]}
          </motion.div>
        </AnimatePresence>
      </motion.div>
      <div className="x1c4vshn">
        <FooterComponent paginate={paginate} count={count} page={page}/>
      </div>
    </div>;
}
